import React from "react";
import "./style.css";
import { ContractDetail, DiscountDetail } from "../../utils/interfaces/storelogo";

interface RadioButtonProps {
  label: string;
  checked: string;
  onChange: (event: string) => void;
  buttons: ContractDetail[];
  discounts?: DiscountDetail[];
  billingTypes?: string[];
}

const RadioButton: React.FC<RadioButtonProps> = ({
  label,
  buttons,
  checked,
  onChange,
  discounts,
  billingTypes,
}) => {
  const setDiscount = (id: string) => {
    if(discounts && discounts.length > 0) {
      const discount = discounts.find((item) => item.code === id);
      return discount ? discount.percent : "0";
    }
  }

  return (
    <div className="flex flex-col md:flex-row md:items-center mb-2">
      <label className="font-bold text-grey-scale-slate font-lato mr-2 mt-2">
        {label}
      </label>
      <div className="radio-button-group mt-2 compact-radio-group">
        <div className="flex h-full w-full">
          {buttons &&
            buttons.map((button, index) => (
              <div
                key={`radio-btn-${index}`}
                data-track={`radio-btn-${index}`}
                className="flex flex-col items-stretch p-0 m-0 h-full radio-btn-col"
              >
                <input
                  id={`radio-btn-${index}`}
                  className="hidden"
                  type="radio"
                  value={button.code}
                  checked={button.code == checked}
                  onChange={() => onChange(button.code)}
                />
                <label
                  htmlFor={`radio-btn-${index}`}
                  className={`radio-label ${button.code == checked ? "checked" : ""} ${index === buttons.length - 1 ? 'no-border' : ''}`}
                >
                  {button.label}{" "}
                  {discounts && discounts.length > 0 && (
                    <span className="text-red-500">
                      {setDiscount(button.code) !== "0" && `(${setDiscount(button.code)}% off)`}
                    </span>
                  )}
                </label>
                <div
                  className={`billing-type${button.code == checked ? ' selected' : ''}`}
                >
                  {billingTypes && billingTypes[index]}
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default RadioButton;
